import { AppI18NLanguageInfo } from '@/app/i18n/types';
import { createContext } from 'react';

export interface AppContextInfo {
  i18n: {
    lng: string;
    languages: AppI18NLanguageInfo[];
    setLang: (lng: string) => void;
  };
}

const app: AppContextInfo = {
  i18n: {
    lng: 'en',
    languages: [],
    setLang: () => {},
  },
};

const AppContext: React.Context<AppContextInfo> = createContext(app);
AppContext.displayName = 'AppContext';

export default AppContext;
